var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.$t('标题')}},[_c('el-input',{attrs:{"placeholder":"请输入标题"},model:{value:(_vm.data.title),callback:function ($$v) {_vm.$set(_vm.data, "title", $$v)},expression:"data.title"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }